import http from 'plugins/axios';

export default {
  getContentList() {
    return http.get({
      url: '/la/admin/text/list'
    });
  },
  createContent(data) {
    return http.post({
      url: '/la/admin/text/add',
      data
    });
  },
  updateContent(data) {
    return http.post({
      url: '/la/admin/text/update',
      data
    });
  },
  removeContent(id) {
    return http.post({
      url: `admin/text/del/${id}`
    });
  }
};
